module.exports = __webpack_public_path__ + "static/img/Thumbs.a1c0559.db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/Thumbs.db
// module id = 677
// module chunks = 1